import { Alert } from '@cmsgov/ds-medicare-gov';
import * as PropTypes from 'prop-types';
import React from 'react';
import '../css/validation.alert.css';

const ValidationAlerts = props => {
    const getMessages = () => props.validationMessages.map((message, index) => <li key={`alert-${index}`}>{message}</li>);
   
    if (props.validationMessages.length === 0)
        return null;
    return <>
        <Alert
            heading={props.heading}
            headingId={'alertHeader'}
            role={'alert'}
            variation={'error'}
        >
            <ul>{getMessages()}</ul>
        </Alert>
    </>;
}

ValidationAlerts.propTypes = {
    validationMessages: PropTypes.array,
    heading: PropTypes.string,
};

ValidationAlerts.defaultProps = {
    validationMessages: [],
    heading: null,
};

export default ValidationAlerts;